function codeMirrorTheme() {
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'duotone-dark' : 'default';
}

let editors = [];

document.addEventListener('themechange', function() {
  let theme = codeMirrorTheme();
  editors.forEach(function(editor) { editor.setOption('theme', theme); });
});

$(document).on("turbolinks:load", function() {
  if(window.CodeMirror) {
    editors = [];

    $(".codeeditor").each(function() {
      let editor = CodeMirror.fromTextArea(this, {
        lineNumbers: true,
        theme: codeMirrorTheme(),
        mode: 'javascript',
        height: 200,
        autoRefresh: true
      });
      editor.setSize("100%", 200);
      editors.push(editor);
    });
    $(".codeeditor-shell").each(function() {
      let editor = CodeMirror.fromTextArea(this, {
        lineNumbers: true,
        theme: codeMirrorTheme(),
        mode: 'shell',
        height: 600,
        autoRefresh: true
      });
      editor.setSize("100%", 600);
      editors.push(editor);
    });
  }
});
